/**
 * Enum NAME → something an operator reads.
 *
 * Written for the executed-step timeline (EN-5167), where the API sends enum
 * names ("FollowUpQuestion", "WaitingWorkflowEvent") in place of the raw
 * integers Retool's tables showed. It moved out of `WorkflowsPanel` when the
 * Baselines page (EN-5168) needed the same thing for measurement types and
 * comparators, since the rule is generic and nothing about it is workflow-
 * specific. `WorkflowsPanel/workflowStep.ts` re-exports it so its own callers
 * and tests kept working untouched.
 */

/** "FollowUpQuestion" → "Follow-up question". */
export function humanizeEnumName(value: string | null | undefined): string {
  if (!value) return "";
  const spaced = value.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
  const sentence = spaced.charAt(0) + spaced.slice(1).toLowerCase();
  // The one compound the generic rule gets wrong.
  return sentence.replace(/^Follow up/, "Follow-up");
}
